import React from 'react';
import * as actDiscount from 'actions/library/discount';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ConfirmActionModal from 'components/ConfirmActionModal';
import { isDirty } from 'redux-form';
import { browserHistory } from 'react-router';
import { askConfirmAction } from 'actions/confirm-action';
import { push } from 'react-router-redux';
import ConfirmDeleteModal from './ConfirmDeleteModal';
import styles from './Discount.css';
import List from './List';
import ActionBar from './ActionBar';

class Discount extends React.Component {
  componentDidMount() {
    this.props.dispatch(actDiscount.pageRequest());
    browserHistory.listenBefore(location => {
      // this is still hacky, don't copy paste this
      if (this.props.isDirtyDiscount && !this.props.nextAction) {
        this.props.dispatch(askConfirmAction(push(location)));
        return false;
      }
    });
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <ActionBar />
        <List />
        <ConfirmActionModal />
        <ConfirmDeleteModal />
      </div>
    );
  }
}

Discount.propTypes = {
  dispatch: PropTypes.func,
};

function mapStateToProps(state) {
  const isDirtyDiscount = isDirty('discount')(state);
  const { nextAction } = state.confirmAction;
  return { isDirtyDiscount, nextAction };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Discount);
